import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { UpdateFlightCurrentMonthDtoMapper, UpdateFlightCurrentMonthErrorsMapper } from '../mappers';
import { UpdateFlightCurrentMonthDto } from '../dtos';

export type IUpdateFlightCurrentMonthRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type IUpdateFlightCurrentMonthRepo = IRepo<[UpdateFlightCurrentMonthDto], IUpdateFlightCurrentMonthRepoResponse>;

export const UpdateFlightCurrentMonthRepoType = Symbol.for('UpdateFlightCurrentMonthRepoType');

@bind(UpdateFlightCurrentMonthRepoType)
export class UpdateFlightCurrentMonthRepo implements IUpdateFlightCurrentMonthRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: UpdateFlightCurrentMonthDto) {
    try {
      const body = new FormData();
      const mappedBody = UpdateFlightCurrentMonthDtoMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = urlMaker('/api/admin/this_month/change');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = UpdateFlightCurrentMonthErrorsMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else if (result.status === 422) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
